/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:59:51
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 15:59:51
 */
import req from "@/utils/request";

//  微信列表查询
export const selectListPage = (params) => req.post("/media-service/m/wxGrant/selectListPage", params);

//  组织架构树
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);

// 公众号授权
export const getPreAuthCodet = (params) => req.post("/media-service/m/wxGrant/getPreAuthCode", params);

// 删除授权人信息列表
export const deleteById = (params) => req.post("/media-service/m/wxGrant/deleteById", params);